<template>
    <form >
        <div class="primary-item">
            <ui-input
                v-model="dataModel.email"
                type="text"
                label="E-mail:"
                size="md2" />
        </div>
        <div class="primary-item">
            <ui-input
                v-model="passVerify.password"
                type="password"
                label="Nova Senha:"
                size="md2" />
        </div>
        <div>
            <ui-input
                v-model="passVerify.confirme"
                :blur=" verifyPass(passVerify.confirme)"
                type="password"
                label="Confirmar Senha:"
                size="md2" />
                
        </div>
        <!-- mensagen de atualização de email e senha -->
        <div class="message-password">
            <p>
                {{ passVerify.message }}
            </p>
        </div>
    </form>
</template>

<script>
import { uiInput }   from '@/components/ui/form'

export default {
    name: 'ui-user-access-data',
    components: {
        uiInput
    },
    props: {
        userModel: {
            type: Object,
            default: () => {}
        },
    },

    data() {
        return {
            dataModel: this.userModel,
            passVerify: {
                password: '',
                message: '',
                confirme: ''
            },
        }
    },
    
    methods: {
        verifyPass(password) {
            if (this.passVerify.password != '') {
                var texto = ''
                if (this.passVerify.password.length < 6) {
                    texto = 'A senha deve possuir no minimo 6 digitos'
                } else if ( this.passVerify.password.length > 5 && password != '' ) {
                    if (this.passVerify.password != password) {
                        texto = 'Os campos da senha precisam ser iguais'
                    } else {
                        texto = ''
                        this.dataModel.password = password
                        this.mensageErros('remove-senha')
                    }
                } else if (this.passVerify.password && !password) {
                    texto = 'Os campos da senha precisam ser iguais'
                }
                this.passVerify.message = texto
            } else {
                this.passVerify.message = ''
                this.mensageErros('remove-senha')
            }
            if (this.passVerify.message != '') {
                this.mensageErros('senha')
            }
        },
        mensageErros(value) {
            this.$emit('imput', value, this.passVerify.message)
        },
        validEmail(email) {
            if(email && email.length != 0){
                let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return re.test(email)
            } else return true
        },
    }
}
</script>

<style lang='stylus' scoped>
    @import '../styles.styl'
</style>